import logo from 'assets/images/logo_registered.png';

export default function Logo() {
    return (
        <a href="https://sellonboard.com">
            <img src={logo} className="logo" alt="logo" />
        </a>
    );
}
